import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { EntityPageTemplate } from 'hocs/withEntityPageTemplate';
import { selectEntriesByCoach } from '@redux/features/selectors/entriesSelector';
import { getCoach, updateCoach } from '@redux/features/coachesSlice';
import { getEntries } from '@redux/features/entriesSlice';

export const CoachPage = () => {
  const { coaches } = useSelector((state) => state.coaches);
  const { coachID } = useParams();
  const dispatch = useDispatch();

  const entries = useSelector((state) => selectEntriesByCoach(state, coachID));

  useEffect(() => {
    if (!coaches.map(({ id }) => id).includes(Number(coachID))) {
      dispatch(getCoach(coachID));
    }
    dispatch(getEntries({ entityRole: 'coach', entityID: coachID }));
  }, []);

  const coach = useMemo(() => coaches.find(({ id }) => id === Number(coachID)), [coaches]);
  const coachEntries = useMemo(
    () => entries.filter((entry) => entry.coaches.some(({ id }) => id == coachID)),
    [entries]
  );
  const formattedCoachEntries = useMemo(
    () =>
      coachEntries.map((entry) => ({
        ...entry,
        locationName: entry.location?.name,
        hallName: entry.hall?.name,
        createdAt: entry.metadata?.createdAt,
      })),
    [coachEntries]
  );

  const handleUpdate = (updatedData) => dispatch(updateCoach(updatedData));

  if (!coach) return null;

  return (
    <EntityPageTemplate
      backButtonPath='database/coaches'
      backButtonText='Список тренерів'
      entity={coach}
      entityType='coach'
      entries={formattedCoachEntries}
      onEntityNameUpdate={handleUpdate}
      noResultsText='У тренера ще не було записів'
    />
  );
};
